import { createServerFn } from "@tanstack/react-start";
import { authMiddleware } from "~/lib/middlewares/auth-middleware";

export const getAuthSession = createServerFn({ method: "GET" })
	.middleware([authMiddleware])
	.handler(async ({ context }) => context.auth);
